import { useState } from 'react';
import { 
  Button, Grid, Typography, Container, ListItem, ListItemText, 
  RadioGroup, Radio, FormControl, FormControlLabel, FormHelperText, IconButton,
  Alert
} from '@mui/material';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { sendCode, sendCodeEmail } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const Step2 = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [disable, setDisable] = useState(false);
  const [value, setValue] = useState('celular');
  const [error, setError] = useState(null);

  if(state == undefined) {
    return <Navigate exact to="/signup" />
  }

  const guardar = async e => {
    e.preventDefault();
    setDisable(true);
    const infoUser = state.info;
    
    if (value == "celular") {
      // Si se manda, sendCode ya lleva al paso 3; si no, devuelve false
      const res = await sendCode(infoUser, "/signup-step3", navigate);
      if (res === false) {
        setDisable(false);
        return setError("Error al enviar el código a su celular");
      }
    } else {
      const info = {
        email: infoUser.email,
        nombre: infoUser.username,
        subject: 'registro',
      }
      const res = await sendCodeEmail(info);
      if(res){
        // El servidor ya no manda el código (lo comprueba él en el paso 3); solo el servidor anterior lo devolvía
        infoUser.codigo = res.data?.codigo ?? null;
        infoUser.emailTel = 'email';
        navigate('/signup-step3', { state: { infoUser } });
      } else {
        setDisable(false);
        return setError("Error al enviar al email");
      }

    }
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid className="container-steps" container spacing={{ lg: 3}}>
        <Grid className="steps" size={{xs: 12, lg: 4}}>
          <img src="/logo-os-24.svg" alt="OneService" />
          <Typography variant="h5" component="h5">Selección de verificación</Typography>
          <Grid className="list-steps" size={12}>
            <ListItem className="step-active" alignItems="flex-start">
              <ListItemText primary="Selección de verificación" />
            </ListItem>
            <ListItem alignItems="flex-start">
              <ListItemText primary="Código" />
            </ListItem>
          </Grid>
        </Grid>
        <Grid className="form-steps" size={8}>
          <form noValidate onSubmit={guardar}>
            <Grid size={12}>
              <IconButton
                className="btn-icon"
                aria-label="back"
                onClick={() => navigate(-1)}
                sx={{width: 55, height: 55}}
              >
                <ChevronLeftIcon sx={{fontSize: 38}} />
              </IconButton>
            </Grid>
            <Grid container sx={{my:2}} spacing={{ sx: 1}}>
              <Grid className="step1" container direction="column">
                <Typography variant="h3" component="h3">Verifica tu cuenta</Typography>
                <Typography component="p">Elige cómo deseas verificar tu cuenta.</Typography>
              </Grid>
              <Grid size={12}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="celular"
                    name="radio-buttons-group"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                  >
                    <FormControlLabel
                      value="email"
                      control={<Radio sx={{ color: "text.secondary" }} />}
                      label="Correo electrónico"
                    />
                    {value === 'email' && (
                      <FormHelperText sx={{ ml: 4, mt: -0.5, mb: 1, color: 'text.secondary' }}>
                        Tu celular quedará sin confirmar. Podrás confirmarlo después desde tu perfil con un código por SMS.
                      </FormHelperText>
                    )}
                    <FormControlLabel
                      value="celular"
                      control={<Radio sx={{ color: "text.secondary" }} />}
                      label="Número celular"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid size={8} sx={{mt: 3}}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={disable}
                >
                  Enviar código
                </Button>
              </Grid>
            </Grid>
            {
              !isEmpty(error) && (
                <Alert className="mss-alert" severity="error">
                  <Typography component="p" color="error.oscuro">{error}</Typography>
                </Alert>
              )
            }
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Step2;